export default __webpack_public_path__ + "static/media/sky_city@3x.863dab34.png";